import { useNavigate } from "react-router-dom"

export function useNavigateBack() {
    const navigate = useNavigate()

    return (fallbackPath: string = "/") => {
        if (window.history.state && window.history.state.idx > 0) {
            navigate(-1)
        } else {
            navigate(fallbackPath)
        }
    }
}
